import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductBundle } from './components/ProductBundle';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { SocialProof } from './components/SocialProof';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-brown selection:bg-brand-terracotta selection:text-white" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main className="flex flex-col w-full overflow-x-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <ProductBundle data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingOffer data-id="element-8" />
        <SocialProof data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}